import React from 'react';

import BudgetPage from "./BudgetPage";

interface BudgetPageProps {}

const BudgetPageContainer: React.FC<BudgetPageProps> = () => {
    return <BudgetPage />
}

export default BudgetPageContainer;